import React from "react";
import TabNavigation from "@/components/TabNavigation";
import { useTranslationContext } from "@/context/TranslationContext";
import { weAllTeam as tr } from "@/constants/translation/weAllTeam.translation";
import { weAllTeam as routes } from "@/libs/routes";

/**
 * WeAll Team sub tabs (Inbox | New Message), shown on every WeAll Team page. The Inbox tab stays active while a
 * conversation is open.
 */
const WeAllTeamTabs = () => {
  const t = useTranslationContext();

  const tabs = [
    {
      label: t(tr.tab_inbox),
      path: routes.inbox,
      isPattern: true,
      childTabPaths: [routes.inbox, "/weall-team-messages/conversation/*"],
    },
    {
      label: t(tr.tab_new),
      path: routes.newMessage,
    },
  ];

  return (
    <div className="weall-team-tabs content-moderation-tabs">
      <TabNavigation tabs={tabs} />
    </div>
  );
};

export default WeAllTeamTabs;
